import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const EmptyMessage: React.FC<SvgIconProps> = ({
  viewBox = '0 0 60.088 72.685',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(-202.953 -116.875)"
    >
      <rect
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        width="50.774"
        height="31.272"
        rx="1.199"
        transform="translate(211.268 140.783)"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M261.819,142.012l-25.165,19.607L211.49,142.012"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="18.874"
        y2="14.705"
        transform="translate(242.945 156.718)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        y1="14.705"
        x2="18.874"
        transform="translate(211.49 156.718)"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M253.923,172.056v16.5h-49.97V117.875h33.492a16.478,16.478,0,0,1,16.478,16.478v6.43"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M253.923,133.578h-15.7v-15.7"
      />
    </g>
  </SvgIcon>
);

export default EmptyMessage;
